import request from '@/api/request.js'

/**
 * 音效版权档案与展示策略接口。
 *
 * 版权相关接口独立于 sounds 和 tag，避免普通音效信息保存时意外覆盖
 * 审核结论或展示限制。
 */
const apis = {
  /**
   * 获取后台表单的枚举和展示预设矩阵。
   *
   * @param {Object} params 可选查询参数
   * @returns {Promise}
   */
  options(params = {}) {
    return request({ url: '/admin_sound_rights/options', method: 'GET', params })
  },

  /**
   * 分页读取版权维护工作台列表。
   *
   * @param {Object} params 筛选和分页参数
   * @returns {Promise}
   */
  lists(params = {}) {
    return request({ url: '/admin_sound_rights/lists', method: 'GET', params })
  },

  /**
   * 读取单个音效的版权档案关联、展示策略和变更摘要。
   *
   * @param {Object} params 必须包含 sound_id
   * @returns {Promise}
   */
  read(params) {
    return request({ url: '/admin_sound_rights/read', method: 'GET', params })
  },

  /**
   * 保存音效的主要版权档案关联和展示策略。
   *
   * @param {Object} params 包含 sound_id、assignment 和 exposure_policy
   * @returns {Promise}
   */
  save(params) {
    return request({ url: '/admin_sound_rights/save', method: 'POST', data: params })
  }
}

export default apis
